import React from 'react';
import SkuDetailSection from './SkuDetailSection/SkuDetailSection';
import { useCalculationRedistributionSectionData } from './useCalculationRedistributionSectionData';

interface CalculationRedistributionSourceSectionProps {
  onShowSkuInfoChanged?: (showSkuInfo: boolean) => void;
}

const CalculationRedistributionSourceSection: React.FC<
  CalculationRedistributionSourceSectionProps
> = ({ onShowSkuInfoChanged }) => {
  const { redistributionData, showExecutionResult, executionResultLoading } =
    useCalculationRedistributionSectionData('Source');

  if (redistributionData) {
    return (
      <SkuDetailSection
        sourceOrTarget="Source"
        redistributionData={redistributionData}
        showExecutionResult={showExecutionResult}
        executionResultLoading={executionResultLoading}
        onShowSkuInfoChanged={onShowSkuInfoChanged}
      />
    );
  } else {
    return null;
  }
};

const MemoCalculationRedistributionSourceSection = React.memo(
  CalculationRedistributionSourceSection,
);
MemoCalculationRedistributionSourceSection.displayName = 'CalculationRedistributionSourceSection';

export default MemoCalculationRedistributionSourceSection;
